/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { useTranslation } from "react-i18next";
import { AuroraBackground } from "@/components/AuroraBackground";
import { Reveal } from "@/components/Reveal";
import { StoreBadgeGroup } from "@/components/StoreBadges";
import { Shield, Lock, Eye, ServerOff, FileText, Key } from "lucide-react";

const PrivacyVsLlmPage = () => {
  const { t } = useTranslation("site");
  const tk = (k, fb) => t(`privacyLlm.${k}`, fb);
  return (
    <>
      <section className="relative pb-12">
        <AuroraBackground variant="soft" />
        <div className="relative mx-auto max-w-7xl px-5 lg:px-8 pt-8 lg:pt-12">
          <Reveal>
            <p className="eyebrow">{tk("kicker")}</p>
            <h1 className="mt-3 font-serif text-[2.4rem] sm:text-5xl lg:text-[4rem] tracking-tight font-light leading-[1.05] max-w-4xl">
              {tk("title1")}{" "}<em className="italic aurora-shimmer-text">{tk("title2")}</em>{" "}{tk("title3")}
            </h1>
            <p className="mt-6 max-w-2xl text-white/72 text-lg font-light">{tk("subtitle")}</p>
            <div className="mt-8"><StoreBadgeGroup startLabel={tk("cta")} /></div>
          </Reveal>
        </div>
      </section>

      <section className="relative py-16">
        <div className="mx-auto max-w-6xl px-5 lg:px-8 grid md:grid-cols-2 gap-5">
          {[
            { icon: <ServerOff size={20} />, title: tk("card1T"), body: tk("card1B") },
            { icon: <Lock size={20} />, title: tk("card2T"), body: tk("card2B") },
            { icon: <Eye size={20} />, title: tk("card3T"), body: tk("card3B") },
            { icon: <Key size={20} />, title: tk("card4T"), body: tk("card4B") },
            { icon: <FileText size={20} />, title: tk("card5T"), body: tk("card5B") },
            { icon: <Shield size={20} />, title: tk("card6T"), body: tk("card6B") },
          ].map((c) => (
            <Reveal key={c.title}>
              <div className="aurora-card p-7 h-full bg-[var(--aurora-coach)]/65">
                <span className="size-11 rounded-2xl bg-white/8 flex items-center justify-center text-[var(--aurora-gold)] mb-4">{c.icon}</span>
                <h3 className="font-serif text-xl">{c.title}</h3>
                <p className="mt-2 text-white/72 font-light leading-relaxed">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="relative py-16">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <Reveal>
            <h2 className="font-serif text-3xl sm:text-4xl tracking-tight font-light leading-tight">{tk("loseTitle")}</h2>
            <ul className="mt-7 space-y-4 text-white/80 font-light leading-relaxed text-lg">
              <li>{tk("lose1")}</li>
              <li>{tk("lose2")}</li>
              <li>{tk("lose3")}</li>
              <li>{tk("lose4")}</li>
              <li>{tk("lose5")}</li>
            </ul>
          </Reveal>
        </div>
      </section>

      <section className="relative py-20">
        <div className="mx-auto max-w-3xl px-5 lg:px-8 text-center">
          <Reveal>
            <h2 className="font-serif text-3xl sm:text-4xl tracking-tight font-light">
              {tk("closingTitle1")}{" "}<em className="italic text-[var(--aurora-gold)]">{tk("closingTitle2")}</em>
            </h2>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <StoreBadgeGroup startLabel={t("common.startFree")} />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
};

export default PrivacyVsLlmPage;
